import React from "react";
import { useState } from "react";
import { processEmailNotifications, separatedByCommaCount, valdiatePage, validateEmail } from "../../global";
import { setLoading } from "../../redux/appSlice";
import { getSubAaccountsEmailNotifications, getSubAccountLocations, SaveEmailNotification } from "../../services/userservice";
import UserModal from '../../components/userModal';
import { useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

const EmailNotificationsAdd = ({
    setViewType, emailData, updateEmailData, emailNotificationType, emailNotificationPayload, setEmailNotificationPayload, data, setData, userInfo, dispatch, subtractionNumber
}) => {
    const history = useHistory();

    const currentSA = {
        id: 0,
        name: ''
    };

    const [rowCount, setRowCount] = useState(subtractionNumber || 0);
    const [selectedReportType, setSelectedReportType] = useState([]);
    const [toEmailValidEntry, setToEmailValidEntry] = useState(true);
    const [toEmailTotalEntries, setToEmailTotalEntries] = useState(0);
    const [ccEmailValidEntry, setCcEmailValidEntry] = useState(true);
    const [ccEmailTotalEntries, setCcEmailTotalEntries] = useState(0);
    const [subaccounts, setSubaccounts] = useState([]);
    const [locations, setLocations] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [currentSubAccount, setCurrentSubAccount] = useState(currentSA);
    const [modalTypeEdit, setModalTypeEdit] = useState(false);
    const [subAccWithLoc, setSubAccWithLoc] = useState([]);
    const [EMEditType, setEMEditType] = useState(false);
    const [selectAll, setSelectAll] = useState(false);


    const [currentEditEM, setCurrentEditEM] = useState({ index: 0, currentEM: {} })

    useEffect(async () => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        if (valdiatePage('/customerinfo')) {
            dispatch(setLoading({ data: true }));
            const rs = await getSubAaccountsEmailNotifications(userInfo);
            dispatch(setLoading({ data: false }));
            if (rs.ok) {
                setSubaccounts(rs.data);
            }
        } else {
            history.push('/login');
        }
        return () => {
            source?.cancel('Operation canceled by the user.');
        }
    }, []);

    const updateData = (key, val) => {
        setData({ ...data, [key]: val });
    }

    const onSaveEmail = async () => {
        if (!data.accountNo || data.accountNo.trim() == '') {
            alert('Select Account');
            return;
        }

        if (!emailNotificationPayload.notifications.length) {
            alert('Add at least one record.');
            return;
        }

        dispatch(setLoading({ data: true }));
        let payload = {
            uid: userInfo, accountNo: data.accountNo, notification: emailNotificationPayload.notifications.map(e => ({
                "toEmail": e?.ToEmail,
                "toCc": e?.CcEmail,
                "emailType": e?.emailType,
                "subaccounts": e?.subAccWithLoc.map(i => ({
                    "subaccountId": i.subAccount.id,
                    "locationId": i.locations
                }))
            }))
        };
        const rs = await SaveEmailNotification(payload);
        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
            alert("Email Added Successfully")
            setEmailNotificationPayload(prev => { return { ...prev, notifications: [] } })
            updateEmailData("ToEmail", "")
            updateEmailData("CcEmail", "")
            updateEmailData("emailType", [])
            setSubAccWithLoc([])
            setSelectedReportType([])
            setViewType('list')
        } else {
            alert(rs.msg);
        }
    }

    const onToEmailChange = (e) => {
        updateEmailData("ToEmail", e?.target.value)
        const cnLengthValidated = separatedByCommaCount(e?.target.value);
        setToEmailTotalEntries(cnLengthValidated)
        if (cnLengthValidated > 5)
            setToEmailValidEntry(false)
        else
            setToEmailValidEntry(true)
    }


    const onCcEmailChange = (e) => {
        const cnLengthValidated = separatedByCommaCount(e?.target.value);
        setCcEmailTotalEntries(cnLengthValidated)
        updateEmailData("CcEmail", e?.target.value)
        if (cnLengthValidated > 5)
            setCcEmailValidEntry(false)
        else
            setCcEmailValidEntry(true)
    }



    const getSubAccountsLocations = async (id, name) => {
        dispatch(setLoading({ data: true }));
        const locs = await getSubAccountLocations(userInfo, id);
        dispatch(setLoading({ data: false }));
        if (locs.length > 0) {
            setShowModal(true);
            setLocations(locs);
            setCurrentSubAccount({ id: Number(id), name: name });
            updateData('locations', []);
        } else {
            alert(`Location not found against sub account ${name}`);
            setLocations([]);
            setCurrentSubAccount(currentSA)
        }
    }

    const onSecondClick = () => {
        if (modalTypeEdit) {
            if (data.locations.length > 0) {
                setSubAccWithLoc(subAccWithLoc.map((item) => {
                    return item.subAccount.id == Number(currentSubAccount.id) ? {
                        subAccount: currentSubAccount,
                        locations: data.locations
                    } : item
                }))
                setShowModal(false)
                setModalTypeEdit(false)
            } else {
                alert('Please Select at least One location')
            }
        } else {
            if (data.locations.length > 0) {
                const updatedPages = [...data.subAccounts, Number(currentSubAccount.id)]
                updateData('subAccounts', updatedPages);
                setSubAccWithLoc(prev => [...prev, {
                    subAccount: currentSubAccount,
                    locations: data.locations
                }])
                setShowModal(false)
                setModalTypeEdit(false)
            } else {
                alert('Please Select at least One location')
            }
        }
    }

    const removeSubAccount = (id) => {
        if (window.confirm('Are you sure?') == true) {
            setSubAccWithLoc(subAccWithLoc.filter((item) => { return Number(id) !== item.subAccount.id }))
            let updatedPages = [];
            updatedPages = data.subAccounts.filter((item) => { return Number(id) !== item })
            updateData('subAccounts', updatedPages);
        }
    }

    const editSubAccountLocation = async (id, name) => {
        dispatch(setLoading({ data: true }));
        const locs = await getSubAccountLocations(userInfo, id);
        dispatch(setLoading({ data: false }));
        if (locs.length > 0) {
            setLocations(locs);
            setCurrentSubAccount({ id: Number(id), name })
            setModalTypeEdit(true)
            const findSALocation = subAccWithLoc.find((item) => { return Number(id) === item.subAccount.id })
            updateData('locations', findSALocation.locations);
            setShowModal(true)
        }
    }

    const reset = () => {
        updateData('locations', []);
    }

    const selectAllLocations = (isChecked) => {

        if (isChecked.target.checked) {
            let sublocs = [];
            subaccounts.forEach(async (e, i) => {
                const locs = await getSubAccountLocations(userInfo, e?.id);
                sublocs.push(
                    {
                        "subAccount": {
                            "id": e?.id,
                            "name": e?.info?.shipperName
                        },
                        "locations": locs.map(e => e?.value)
                    }
                )
            })
            updateData("subAccounts", subaccounts.map(e => e?.id))
            setSubAccWithLoc(sublocs)
        } else {
            updateData("subAccounts", [])
            setSubAccWithLoc([])
        }
        setSelectAll(isChecked.target.checked)
    }

    const toFindDuplicates = (arr) => arr.filter((item, index) => arr.indexOf(item) !== index);

    return (
        <>
            {showModal && <UserModal onSecondClick={onSecondClick} response={locations} setShowModal={setShowModal} reset={reset} data={data} updateData={updateData} subAccount={currentSubAccount} />}

            <div className="section-header">
                <h1>Add Email</h1>
            </div>
            <div className="card" style={{ padding: 10 }}>
                <div style={{ textAlign: 'right' }}>
                    <button type='button' className='btn btn-primary' onClick={() => { setViewType('list') }}>Back</button>
                </div>

                <div className="row mt-2">
                    <label className={!toEmailValidEntry ? 'text-danger' : undefined}>
                        To Email: Total Email Count: ({toEmailTotalEntries}) {" "}
                        {!toEmailValidEntry && <label className='text-danger'>
                            Maximum 5 Email Allowed, Each Email separated by a comma.
                        </label>}
                    </label>
                </div>

                <div className="row mt-2">
                    <label className={!ccEmailValidEntry ? 'text-danger' : undefined}>
                        CC Email: Total Email Count: ({ccEmailTotalEntries}) {" "}
                        {!ccEmailValidEntry && <label className='text-danger'>
                            Maximum 5 Email Allowed, Each Email separated by a comma.
                        </label>}
                    </label>
                </div>

                <>  <div className="row mt-3">
                    <div className="col-lg-6 col-sm-12">
                        <label>TO</label>
                        <input type="text" placeholder="Email" className="form-control" maxLength={250} value={emailData.ToEmail} onInput={processEmailNotifications} name={"ToEmail"} onChange={onToEmailChange} />
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <label>CC</label>
                        <input type="text" placeholder="Email" className="form-control" maxLength={250} value={emailData.CcEmail} onInput={processEmailNotifications} name={"CcEmail"} onChange={onCcEmailChange} />
                    </div>

                </div>

                    <div className="row mt-4 section-border">
                        <label>Report Type</label>
                        {
                            emailNotificationType?.map((e) => <div key={e?.id} className="col-lg-3 col-sm-12">
                                <label className="small-switch">
                                    <input type="checkbox" name={e?.reportName} value={e?.id} checked={selectedReportType?.includes(Number(e?.id))} onChange={c => {
                                        if (c.target.checked) {
                                            const reportType = [...selectedReportType, Number(e?.id)]
                                            updateEmailData("emailType", reportType)
                                            setSelectedReportType(reportType);
                                        } else {
                                            const removeReportType = selectedReportType?.filter(i => i !== Number(e?.id))
                                            updateEmailData("emailType", removeReportType)
                                            setSelectedReportType(removeReportType);
                                        }
                                    }} />
                                    <span className="small-slider round"></span>
                                </label>
                                <label className="small-content-check">{e?.reportName}</label>
                            </div>)
                        }
                    </div>

                    <div className="row mt-4 section-border">
                        <h3 style={{ margin: '10px' }}>Add Sub Accounts</h3>

                        <div className="card">
                            {
                                subaccounts && subaccounts.length > 0 &&
                                <>
                                    <table className='table table-md table-bordered'>
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Sub Account</th>
                                                <th>
                                                    <div className="select-all-check">
                                                        <label className="small-switch">
                                                            <input type="checkbox" checked={selectAll} onChange={selectAllLocations} />
                                                            <span className="small-slider round"></span>
                                                        </label>
                                                        <label className="select-all-check-label">Select All</label>
                                                    </div>
                                                </th>
                                                <th style={{ width: "15%" }}>Edit</th>
                                                <th style={{ width: "15%" }}>Remove</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                subaccounts.length > 0 && subaccounts.map((e, index) =>
                                                    <tr key={e?.id}>
                                                        <td>{e?.id}</td>
                                                        <td>
                                                            <div key={index}>
                                                                <label className="small-switch">
                                                                    <input type="checkbox" name={e?.info?.shipperName} value={e?.id} checked={data.subAccounts.includes(Number(e?.id))} onChange={c => {
                                                                        if (c.target.checked) {
                                                                            getSubAccountsLocations(e?.id, e?.info?.shipperName)
                                                                        }
                                                                    }} />
                                                                    <span className="small-slider round"></span>
                                                                </label>
                                                                <label className="small-content-check">{e?.info?.shipperName}</label>
                                                            </div>
                                                        </td>
                                                        <td></td>
                                                        {
                                                            data.subAccounts.includes(Number(e?.id)) &&
                                                            <>
                                                                <td>
                                                                    <button type='button' className='btn btn-sm btn-primary' onClick={() => editSubAccountLocation(e?.id, e?.info.shipperName)}>Edit</button>
                                                                </td>
                                                                <td>
                                                                    <button type='button' className='btn btn-sm btn-primary' onClick={() => removeSubAccount(e?.id)}>Remove</button>
                                                                </td>
                                                            </>
                                                        }
                                                    </tr>)
                                            }
                                        </tbody>
                                    </table>
                                </>
                            }
                        </div>
                    </div>

                    <div className="row mt-4">


                        <div className="col-lg" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                            {EMEditType &&
                                // <div className="col-lg-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                <button type="button" className="btn btn-primary" style={{ marginRight: '5px' }} onClick={() => {
                                    const r = [...emailNotificationPayload.notifications];
                                    r.splice(currentEditEM.index, 0, currentEditEM.currentEM);
                                    setEmailNotificationPayload(prev => { return { ...prev, notifications: r } })
                                    setToEmailTotalEntries(0)
                                    setCcEmailTotalEntries(0)
                                    updateEmailData("ToEmail", "")
                                    updateEmailData("CcEmail", "")
                                    updateEmailData("emailType", [])
                                    updateData("subAccounts", [])
                                    setSubAccWithLoc([])
                                    setSelectedReportType([])

                                    setEMEditType(false)
                                }}>Cancel</button>
                            }
                            <button type="button" className="btn btn-primary" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} onClick={() => {

                                if (!toEmailValidEntry) {
                                    alert('To Email: Maximum 5 Email Allowed, Each Email separated by a comma.');
                                    return;
                                }

                                if (!ccEmailValidEntry) {
                                    alert('CC Email: Maximum 5 Email Allowed, Each Email separated by a comma.');
                                    return;
                                }

                                if (!emailData.ToEmail || emailData.ToEmail.trim() == '') {
                                    alert('Enter TO Email');
                                    return;
                                }

                                const multiToEmail = emailData.ToEmail.split(',');
                                for (let i = 0; i < multiToEmail.length; i++) {
                                    if (validateEmail(multiToEmail[i].trim())) {
                                        alert(`To Email is invalid "${multiToEmail[i]}" on number ${[i + 1]}`);
                                        return false;
                                    }
                                }

                                if (toFindDuplicates(multiToEmail).length > 0) {
                                    alert(`To Email: Found dupicate Email "${toFindDuplicates(multiToEmail.map(e => e?.toUpperCase())).join(", ")}"`);
                                    return false;
                                }

                                const multiCcEmail = emailData.CcEmail.split(',').filter(e => e !== "");
                                for (let i = 0; i < multiCcEmail.length; i++) {
                                    if (validateEmail(multiCcEmail[i].trim())) {
                                        alert(`CC Email is invalid "${multiCcEmail[i]}" on number ${[i + 1]}`);
                                        return false;
                                    }
                                }

                                if (toFindDuplicates(multiCcEmail).length > 0) {
                                    alert(`Cc Email: Found dupicate Email "${toFindDuplicates(multiToEmail.map(e => e?.toUpperCase())).join(", ")}"`);
                                    return false;
                                }

                                if (emailData.emailType <= 0) {
                                    alert('Select at least one Report Type');
                                    return;
                                }

                                if (subAccWithLoc.length <= 0) {
                                    alert('Select at least one Sub Account.');
                                    return;
                                }

                                if (!EMEditType) {
                                    if (rowCount >= 5) {
                                        alert("You can add maximum 5 Email Notifications records")
                                        return
                                    }
                                }

                                if (!EMEditType) {
                                    setRowCount(prev => prev + 1)
                                }

                                if (EMEditType) {
                                    const r = [...emailNotificationPayload.notifications];
                                    r.splice(currentEditEM.index, 0, { ...emailData, subAccWithLoc });
                                    debugger
                                    setEmailNotificationPayload(prev => { return { ...prev, notifications: r } })
                                    setEMEditType(false)
                                } else {
                                    const d = [...emailNotificationPayload.notifications, { ...emailData, subAccWithLoc }]
                                    setEmailNotificationPayload(prev => { return { ...prev, notifications: d } })
                                }


                                updateEmailData("ToEmail", "")
                                updateEmailData("CcEmail", "")
                                updateEmailData("emailType", [])
                                updateData("subAccounts", [])
                                setSubAccWithLoc([])
                                setSelectedReportType([])
                                setToEmailTotalEntries(0)
                                setCcEmailTotalEntries(0)
                                setSelectAll(false)
                            }}>{EMEditType ? "Update" : "Add"}</button>
                        </div>
                    </div></>

                <div className="row table-responsive" style={{ marginTop: '40px' }}>
                    <table className="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th>TO</th>
                                <th>CC</th>
                                <th>Type</th>
                                <th>Remove</th>
                                <th>Edit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                emailNotificationPayload.notifications.map((x, index) => (
                                    <tr key={index}>
                                        <td className="vertical-align">{x.ToEmail.split(",").filter(e => e !== "").join(", ")}</td>
                                        <td className="vertical-align">{x.CcEmail.split(",").filter(e => e !== "").join(", ")}</td>
                                        <td className="vertical-align"><div style={{ width: "120px" }}>{emailNotificationType?.filter(e => (x.emailType?.includes(Number(e?.id)))).map(e => e?.reportName).join(", ")}</div></td>
                                        <td className="vertical-align">
                                            <button type="button" className="btn btn-sm btn-primary" style={{ width: 60 }} onClick={() => {
                                                if (window.confirm('Are you sure?')) {
                                                    setRowCount(prev => prev - 1)
                                                    const r = [...emailNotificationPayload.notifications];
                                                    r.splice(index, 1);
                                                    setEmailNotificationPayload(prev => { return { ...prev, notifications: r } })
                                                }
                                            }}>Remove</button>
                                        </td>
                                        <td className="vertical-align">
                                            <button type="button" className="btn btn-sm btn-primary" style={{ width: 60 }} onClick={() => {

                                                //set currentEM which is updating.
                                                setEMEditType(true)
                                                setCurrentEditEM({ index, currentEM: x })

                                                //remove from list.
                                                const r = [...emailNotificationPayload.notifications];
                                                r.splice(index, 1);
                                                setEmailNotificationPayload(prev => { return { ...prev, notifications: r } })

                                                setToEmailTotalEntries(separatedByCommaCount(x.ToEmail))
                                                setCcEmailTotalEntries(separatedByCommaCount(x.CcEmail))

                                                //fil respected field using EM
                                                updateEmailData("ToEmail", x.ToEmail)
                                                updateEmailData("CcEmail", x.CcEmail)
                                                updateEmailData("emailType", x.emailType)
                                                updateData("subAccounts", x.subAccWithLoc.map(e => e?.subAccount.id))
                                                setSubAccWithLoc(x.subAccWithLoc)
                                                setSelectedReportType(x.emailType)

                                            }}>Edit</button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>

                <div className="col-lg col-sm-12" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                    <button type="button" className="btn btn-primary" onClick={onSaveEmail}>Save</button>
                </div>
            </div></>
    )

}

export default EmailNotificationsAdd;